import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RootScopeService } from '../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../core/rootscope-declare';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RfidMemberService } from '../../../services/rfid-member.service';
import { RFIDMember, SaveMembers } from '../../../../core/services/facility.model';
import { CommonUtil } from '../../../../core/Utils/common-util';
import { FacilityObject } from '../../../../core/services/facility.model';
import { FacilityService } from '../../../../core/services/facility.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';


@Component({
  selector: 'app-add-rfid',
  templateUrl: './add-rfid.component.html',
  styleUrls: ['./add-rfid.component.scss'],
})
export class AddRfidComponent implements OnInit, OnDestroy {

  rootScopeData: RootScopeDeclare;
  isDefaultEmailIdEnabled = 'true';
  useCustomCopy: boolean;
  isDefaultEmailEnabled = 'true';
  prefferedUnit = 'false';
  uploadfile = '';
  uploadForm: FormGroup;
  emailValidator: FormGroup;
  preffredLanguage: string = 'en_US';
  userId: Number;
  displayStep: number;
  uploadFileError = false;
  members: RFIDMember[] = [];
  emailSalutation: string;
  emailContent1: string;
  emailContent2: string;
  emailContent3: string;
  emailContent4: string;
  emailContent5: string;
  currentFacility: FacilityObject;
  private _facilityOnChange: Subscription;
  customEmail: string;
  setcustomEmailOption: boolean;
  showRFIDConfirmationModal = false;
  successfulUsers: Number;
  failedUsers: Number;
  numberOfUsers: Number;
  failedUserInfo: any = [];
  serviceBasePath: string;
  showUnsavedModal: boolean = false;
  hasEditPermission: boolean = true;
  errorCount: number;
  disableAddButton: boolean = false;
  isShowAdd = true;

  @ViewChild('uploadForm', { static: false }) myUploadForm: ElementRef;

  constructor(
    private rootScopeService: RootScopeService,
    private router: Router,
    private formBuilder: FormBuilder,
    private _rfidMemberService: RfidMemberService,
    private commonUtil: CommonUtil,
    private _facilityService: FacilityService,
    private _amplitudeService: AmplitudeAnalyticsService,
    private _loader: HaloLoaderService) { }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  setPageName(): void {
    this.rootScopeData.pageName = 'add-rfid';
  }

  ngOnInit() {
    this.getRootScopeData();
    this.setPageName();

    this.uploadForm = this.formBuilder.group({
      chooseFile: [''],
    });
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
      this.setDefaultValues();
    });
    this.currentFacility = this._facilityService.selectedFacility();

    this.emailValidator = this.formBuilder.group({
      email: ['', Validators.compose([
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+[.][A-Za-z]{2,50}$/)]
      )]
    });
    // user permission
    if (this.currentFacility.summary.userRights.facility === 'F')
      this.hasEditPermission = true;
    else
      this.hasEditPermission = false;
    this.setDefaultValues();
  }
  
  ngOnDestroy(): void {
    this._facilityOnChange?.unsubscribe();
  }

  setDefaultEmailContent() {
    this.emailSalutation = this.commonUtil.translateText('HI');
    this.emailContent1 = this.commonUtil.translateText('WELCOME.EMAIL.MESSAGE.1');
    this.emailContent2 = this.commonUtil.translateText('PASSWORD.MESSAGE.2');
    this.emailContent3 = this.commonUtil.translateText(' ENJOY.YOUR.WORKOUT ');
    this.emailContent4 = this.commonUtil.translateText('Halo Fitness Cloud');
    this.emailContent5 = this.commonUtil.translateText('www.halo.fitness ');
  }

  setDefaultValues(): void {
    this.displayStep = 1;
    this.uploadFileError = false;
    this.uploadfile = '';
    this.serviceBasePath = environment.servicePath;
    this.userId = this.rootScopeData.currentUser.userId;        
    if (this.myUploadForm) {
      this.myUploadForm.nativeElement.reset();
    }
    this.setFromEmailToggle('true');
    this.setEmailToggle('true');
    this.prefferedUnit = 'false';
    this.rootScopeData.isPageHasUnsavedChanges = false;
    this.setDefaultEmailContent();
  }

  get emailValidatorForm() {
    return this.emailValidator.controls;
  }
  onCancel(): void {
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.openUnsavedModal();
    } else {
      this.rootScopeData.isPageHasUnsavedChanges = false;
      this.router.navigate(['/facility/rfid']);
    }
  }
  setFromEmailToggle(setValue: string) {
    this.setDraftedFlag();
    this.isDefaultEmailIdEnabled = setValue;
    if (setValue === "false") {
      this.setcustomEmailOption = true;
    }
    else { this.setcustomEmailOption = false; this.setUserPrefEmail(''); }
  }
  setEmailToggle(setValue: string) {
    this.isDefaultEmailEnabled = setValue;
    this.useCustomCopy = !JSON.parse(this.isDefaultEmailEnabled);
    this.setDraftedFlag();
  }
  setPrefferedUnitToggle(setValue: string) {
    this.prefferedUnit = setValue;
    this.setDraftedFlag();
  }

  onFileSelect(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0] as File;
      this.uploadForm.get('chooseFile')?.setValue(file);
      this.uploadFileError = false;
      this.uploadfile = file.name;
      this.setDraftedFlag();
    }
  }
  uploadRFIDMemberList() {
    this.errorCount = 0;
    const formData = new FormData();
    formData.append('file', this.uploadForm.get('chooseFile')?.value);
    this.showRFIDConfirmationModal = false;
    this._amplitudeService.logEvent({elementName: 'Upload Excel File', action: 'Submit'});
    this._rfidMemberService.excelUpload(formData).subscribe(
      (data) => {
        this.numberOfUsers = Number(data.numberOfUsers);       
        if(this.numberOfUsers === 0){
          this.showRFIDConfirmationModal = true;
        } else {
          this.members = data.memberList;
          for (let i = 0; i < data.memberList.length; i++) {
            if (data.memberList[i].isEmailError == "true" || data.memberList[i].isGenderError == "true" || data.memberList[i].isRfidError == "true") {
              this.errorCount++;
            }
          }
          if (data.numberOfUsers == this.errorCount) { this.disableAddButton = true; }
          else { this.disableAddButton = false; }
          this.displayStep = 2;
        }
      },
      (error) => {
        this.uploadFileError = true;
        this.uploadfile = '';
        console.error('API failed.');
      }
    );
  }
  getContent(innerText: string, fieldname: string) {
    if (fieldname === 'emailSalutation') this.emailSalutation = innerText;
    if (fieldname === 'emailContent1') this.emailContent1 = innerText;
    if (fieldname === 'emailContent2') this.emailContent2 = innerText;
    if (fieldname === 'emailContent3') this.emailContent3 = innerText;
    if (fieldname === 'emailContent4') this.emailContent4 = innerText;
    if (fieldname === 'emailContent5') this.emailContent5 = innerText;
  }
  backToStep1() {
    this.displayStep = 1;
  }
  getPreffredLanguage(language: string) {
    this.preffredLanguage = language;
  }
  getUserPrefEmail(email: string) {
    this.customEmail = email;
  }

  setUserPrefEmail(email: string) {
    this.emailValidator.patchValue({ email: email });
  }

  addRFIDMembers() {
    let selectedUnit = this.prefferedUnit == 'false' ? 'I' : 'M';
    let data: SaveMembers = {
      memberList: this.members,
      preferredLanguage: this.preffredLanguage,
      preferredUnit: selectedUnit,
      emailSalutation: this.emailSalutation,
      emailContent1: this.emailContent1,
      emailContent2: this.emailContent2,
      emailContent3: this.emailContent3,
      emailContent4: this.emailContent4,
      emailContent5: this.emailContent5,
      facilityId: this.currentFacility.facilityId,
    };

    if (this.isDefaultEmailIdEnabled != 'true') data.customEmail = this.customEmail;
    let errorInfo: { email: string; duplicateRfid?: string; emailError?: string; genderError?: string; };
    let errorInfoArray: any = [];
    this._loader.startProcess();
    this._amplitudeService.logEvent({elementName: 'Add Members', action: 'Submit'});
    this._rfidMemberService.saveRFIDMemberList(data).subscribe(
      (data) => {
        this._loader.endProcess();
        this.showRFIDConfirmationModal = true;
        this.successfulUsers = Number(data.successfulUsers);
        this.failedUsers = Number(data.failedUsers);
        this.numberOfUsers = Number(data.numberOfUsers);  

        if (this.failedUsers > 0) {
          data.memberList.map(function (memberList: RFIDMember, index: number) {
            errorInfo = { "email": memberList.email, "duplicateRfid": memberList.isDuplicateRfid, "emailError": memberList.isEmailError, "genderError": memberList.isGenderError };
            errorInfoArray[index] = errorInfo;
          });
        }
        this.failedUserInfo = errorInfoArray;
        this.rootScopeData.isPageHasUnsavedChanges = false;
      },
      (err: any) => {
        this._loader.endProcess();
        console.log(err);
        this.rootScopeData.customPopupData = {
          title: 'OOPS',
          message: 'CUSTOM.LOADER.ERROR.MSG.APIFAILED',
          isWarningPopup: true,
          ctaButtonLabel: 'OK',
          isSecondaryTextButton: false,
          hideSecondaryButton: true
        };
        this.rootScopeData.showCustomModal = true;
        //this.showRFIDConfirmationModal = true;
      },
    );

  }
  // from table
  // (onUpdate)="onUpdate($event)"
  // [needToUpdateOnParent]='true'
  onUpdate(members: RFIDMember[]) {
    this.members = members;
    this.errorCount = 0;
    for (let i = 0; i < this.members.length; i++) {
      if (this.members[i].isEmailError == "true" || this.members[i].isGenderError == "true" || this.members[i].isRfidError == "true") {
        this.errorCount++;
      }
    }
    this.isShowAdd = this.errorCount == 0 && this.members.findIndex(m => m.isEditFormOpen) == -1;
    if (this.members.length == this.errorCount) { this.disableAddButton = true; } else { this.disableAddButton = false; }

  }

  backToMemberList() {
    if(this.numberOfUsers > 0){
      this.router.navigate(['/facility/rfid']);
    }else{
      this.showRFIDConfirmationModal = false;
    }    
  }

  setDraftedFlag(): void {
    this.rootScopeData.isPageHasUnsavedChanges = true;
  }

  openUnsavedModal(): void {
    this.showUnsavedModal = true;
  }

  onPositiveConfirmation(): void {
    this.closeUnsavedModal();
    this.rootScopeData.isPageHasUnsavedChanges = false;
    this.router.navigate(['/facility/rfid']);
  }

  closeUnsavedModal(): void {
    this.showUnsavedModal = false;
  }
}
